import axios from 'axios';

const features = [
  'maven.feature.aiPoweredRouting',
  'maven.feature.askMaven',
  'maven.feature.billingMetrics',
  'maven.feature.contextVariables',
  'maven.feature.policyEditorV2',
  'maven.feature.recommendedActionBots',
  'maven.feature.recommendedActionKBs',
  'maven.feature.settings',
  'maven.feature.themes',
  'maven.feature.analytics',
  'maven.feature.sdePage',
  'maven.automationlookup.v2',
  'maven.automationlookup.temporaryKbKey',
  'maven.feature.showMaxNumberRecommendations',
  'maven.feature.isMigratedCcsV2',
  'maven.feature.new.ccsV2',
  'maven.ccs.isV1Whitelist',
  'maven.feature.textareaEditor',
  'maven.feature.displayPolicyAnalytics',
  'maven.agentassist.enabled',
  'maven.feature.showUnauthSdeToggle',
];

export default class MavenFeatures {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async getFeatures(accountId) {
    const { data } = await axios.post(`${this.baseURL}/account/${accountId}/v1/switch/multi`, features);
    return data;
  }

  async getFeature(feature, accountId) {
    const result = await axios.get(`${this.baseURL}/account/${accountId}/v1/switch/${encodeURIComponent(feature)}`);
    return result.data;
  }
}
